namespace GeniuzPOS.InitialData {
    export interface PsShopRow {
        Id?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        BranchName?: string;
        ShopAddress?: string;
        ShopRegName?: string;
        ShopRegAddressLine1?: string;
        ShopRegAddressLine2?: string;
        ShopRegAddressLine3?: string;
        ShopRegId?: string;
        ShopTaxId?: string;
        PromptPayLink?: string;
        QRCodeAccount?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ShopFullName?: string;
        ShopTypeName?: string;
        ShopGroupName?: string;
        Email?: string;
        TelId?: string;
        ShopNameEN?: string;
        BranchNameEN?: string;
        ShopAddressEN?: string;
        ShopBuildingName?: string;
        ShopBuildingNo?: string;
        ShopStreetName?: string;
        ShopDistrict?: string;
        ShopCity?: string;
        ShopProvince?: string;
        ShopPostalCode?: string;
        ShopCountryCode?: string;
        BranchTaxCode?: string;
        ErpStore?: string;
        ErpChannel?: string;
        BranchNameDesc?: string;
        BranchNameDescEn?: string;
        ShopBuildingNameEn?: string;
        ShopBuildingNoEn?: string;
        ShopStreetNameEn?: string;
        ShopDistrictEn?: string;
        ShopProvinceEn?: string;
        ShopCityEn?: string;
    }

    export namespace PsShopRow {
        export const idProperty = 'ShopId';
        export const nameProperty = 'ShopFullName';
        export const localTextPrefix = 'InitialData.PsShop';
        export const lookupKey = 'InitialData.PsShop';

        export function getLookup(): Q.Lookup<PsShopRow> {
            return Q.getLookup<PsShopRow>('InitialData.PsShop');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';
        export const readPermission = '*';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            BranchName = "BranchName",
            ShopAddress = "ShopAddress",
            ShopRegName = "ShopRegName",
            ShopRegAddressLine1 = "ShopRegAddressLine1",
            ShopRegAddressLine2 = "ShopRegAddressLine2",
            ShopRegAddressLine3 = "ShopRegAddressLine3",
            ShopRegId = "ShopRegId",
            ShopTaxId = "ShopTaxId",
            PromptPayLink = "PromptPayLink",
            QRCodeAccount = "QRCodeAccount",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ShopFullName = "ShopFullName",
            ShopTypeName = "ShopTypeName",
            ShopGroupName = "ShopGroupName",
            Email = "Email",
            TelId = "TelId",
            ShopNameEN = "ShopNameEN",
            BranchNameEN = "BranchNameEN",
            ShopAddressEN = "ShopAddressEN",
            ShopBuildingName = "ShopBuildingName",
            ShopBuildingNo = "ShopBuildingNo",
            ShopStreetName = "ShopStreetName",
            ShopDistrict = "ShopDistrict",
            ShopCity = "ShopCity",
            ShopProvince = "ShopProvince",
            ShopPostalCode = "ShopPostalCode",
            ShopCountryCode = "ShopCountryCode",
            BranchTaxCode = "BranchTaxCode",
            ErpStore = "ErpStore",
            ErpChannel = "ErpChannel",
            BranchNameDesc = "BranchNameDesc",
            BranchNameDescEn = "BranchNameDescEn",
            ShopBuildingNameEn = "ShopBuildingNameEn",
            ShopBuildingNoEn = "ShopBuildingNoEn",
            ShopStreetNameEn = "ShopStreetNameEn",
            ShopDistrictEn = "ShopDistrictEn",
            ShopProvinceEn = "ShopProvinceEn",
            ShopCityEn = "ShopCityEn"
        }
    }
}
